export const hokageMigration = {
  // サービス終了のお知らせ（モーダル・バナー共通）
  noticeTitle: "Hokageはサービスを終了します",
  noticeBody: (args: { endDate: string }) =>
    `Hokageは${args.endDate}をもって\nサービスを終了します。`,
  noticeTransferLead: "サービスはCarinaに引き継ぎます",
  noticeTransferItemsTitle: "引き継ぎ内容",
  noticeTransferItems: [
    "ユーザーアカウント情報",
    "メッセージ内容",
    "購入画像・動画",
    "お気に入り・いいね履歴",
    "所持ポイント",
    "メールアドレス・パスワード",
  ],
  noticeExistingAccountTitle: "Carinaにアカウントをお持ちの方",
  noticeExistingAccountBody:
    "上記の内容は引き継げません。所持ポイントのみ、お問い合わせいただければCarinaのアカウントへ移行できます。",
  noticeGuide:
    "Carinaへ引き継ぐには、メールアドレスとパスワードを設定してください",
  noticeCta: "引き継ぎの準備をする",
  noticeLater: "あとで",
  bannerTitle: "Hokageはサービス終了予定です",
  bannerBody:
    "Carinaへ引き継ぐには、メールアドレスとパスワードを設定してください",

  // 引き継ぎ準備画面
  pageTitle: "Carinaへの引き継ぎ準備",
  description:
    "Carinaのログイン画面で使うメールアドレスとパスワードを設定してください。Hokageでも同じ内容でログインできるようになります。",
  emailLabel: "メールアドレス",
  passwordLabel: "新しいパスワード",
  confirmPasswordLabel: "新しいパスワード（確認）",
  submit: "設定する",
  error: {
    emailRegistered: "このメールアドレスはすでに使われています",
    invalidEmail: "メールアドレスの形式が正しくありません",
    generic: "設定に失敗しました。時間をおいてもう一度お試しください",
  },

  // 設定完了
  completeTitle: "引き継ぎの準備ができました",
  completeEmailLabel: "設定したメールアドレス",
  completeGuide:
    "Carinaのログイン画面で、このメールアドレスとパスワードでログインしてください",
  completePasswordNote: "パスワードは忘れないようメモしてください",
  openCarinaStore: "CarinaをApp Storeで開く",

  // 移行済み画面（ログイン時に移行済みと判定されたとき）
  migratedTitle: "Carinaへ移行済みです",
  migratedBody: "Hokageのアカウントは、Carinaへ移行されています",
  migratedGuide:
    "Carinaのログイン画面で、Hokageで設定したメールアドレスとパスワードでログインしてください",

  // サービス終了画面（締め切り以降）
  endedTitle: "Hokageはサービスを終了しました",
  endedGuide:
    "引き継ぎの準備をした方は、Carinaのログイン画面で設定したメールアドレスとパスワードでログインしてください",
} as const;
